import { TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MicroempresarioService } from '../../services/microempresario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { personaJuridica } from '../../models/persona-juridica';
import { AlertService } from 'src/app/services/alert.service';
import { SweetAlertService } from '../../../services/sweet-alert.service';
import { BancoldexService } from 'src/app/comun/services/bancoldex.service';
import { NumeroDocumentoService } from '../../services/numero-documento.service';
import { Localidad } from 'src/app/comun/models/localidad';
import { LOCALIDADES_BOGOTA } from 'src/app/comun/data/localidades-bogota';
import {
  numeroDocumentoPorTipoDocValidator,
  getDocumentPatternMessage,
} from 'src/app/shared/utils/form-validators.util';
import { formatPesosCop, parsePesosCop } from 'src/app/shared/utils/currency-cop.util';
import { Constantes } from 'src/app/comun/data/constantes';
//jQuery
declare var $: any;

@Component({
    selector: 'actualizar-persona-juridica',
    templateUrl: './actualizar-persona-juridica.html',
    providers: [TitleCasePipe],
    standalone: false
})
export class ActualizarPersonaJuridica implements OnInit {
  messageAlert: string = '';
  //Selects
  documentos: any[] = [];
  generos: any[] = [];
  ciius: any[] = [];
  anios: any[];
  departamentos: any[] = [];
  ciudades: any[] = [];
  listaTiposCont: any[]

  fuentesInformacion:any[];
  isReferido:boolean=false;
  isOtraFuente:boolean=false;
  paises: any[]=[];
  ventasMinimas:number=0;
  msjErrorValorVentas:string=null;
  isPasaporte:boolean=false;
  idPaisOrigenActual: number;
  titleModal: string = 'R';
  isAutorizarDatos: boolean = false;
  /** Lista de dominios de correo no permitidos (PAR-160), cargada desde el back. */
  dominiosCorreoBloqueados: string[] = [];
  readonly idBogota = 11001;
  private static readonly PAR_DOMINIOS_CORREO_BLOQUEADOS = 'PAR-160';
  localidades: ReadonlyArray<Localidad> = LOCALIDADES_BOGOTA;
  currentStep = 1;
  private readonly step1Fields: string[] = [
    'razonSocial',
    'numeroDocumento',
    'confirmNit',
    'digitoVerificacion',
    'camaraComercioVigente',
    'anioVentas',
    'valorVentas',
    'idDepartamento',
    'idCiudad',
    'codigoCiiu',
    'tiposContacto',
  ];
  private readonly step2Fields: string[] = [
    'personaDeContacto',
    'primerNombre',
    'primerApellido',
    'idTipoDocIdentidad',
    'numeroDocumentoP',
    'confirmNumeroDocumento',
    'idGenero',
    'numeroCelular',
    'correoElectronico',
    'idFuenteNeocredito',
  ];
  constructor(
    private readonly _parametro: ParametrosService,
    private readonly _microempresario: MicroempresarioService,
    private readonly _alert: AlertService,
    private readonly route: Router,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly _sweetAlert:SweetAlertService,
    public title: TitleCasePipe,
    private readonly _bancoldexService: BancoldexService,
    private readonly _numeroDocumento: NumeroDocumentoService
  ) { 
    this.getPaises();
  }

  public juridicoForm = this.formBuilder.group({
    idEmpresario: null,
    idUsuario: null,
    idPersonaEmpJuridico: null,
    razonSocial: ['', Validators.required],
    numeroDocumento: ['', Validators.required],
    confirmNit: [null, Validators.required],
    digitoVerificacion: [{ value: '', disabled: true }, Validators.required],
    anioVentas: ['', Validators.required],
    valorVentas: ['', Validators.required],
    idDepartamento: ['', [ Validators.required,Validators.min(1)]],
    idCiudad: ['', [ Validators.required,Validators.min(1)]],
    idLocalidad: [''],
    codigoCiiu: ['', Validators.required],
    personaDeContacto: ['', Validators.required],
    tipoPersonaOtro: ['', Validators.maxLength(30)],
    primerNombre: ['', Validators.required],
    segundoNombre: [''],
    primerApellido: ['', Validators.required],
    segundoApellido: [''],
    idTipoDocIdentidad: ['', Validators.required],
    idTipoEntidad_NeoTipoEntidad: ['', Validators.required],
    idTipoSociedad: [''],
    numeroDocumentoP: [
      '',
      [
        Validators.required,
        numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocIdentidad'),
      ],
    ],
    confirmNumeroDocumento: [
      null,
      [
        Validators.required,
        numeroDocumentoPorTipoDocValidator(() => this.documentos, 'idTipoDocIdentidad'),
      ],
    ],
    idGenero: ['', Validators.required],
    numeroCelular: ['', Validators.required],
    correoElectronico: [
      '',
      [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*\.[a-z]{2,4}$'),
      ],
    ],
    ciiuNombre: '',
    minoria:[''],
    minoriaDescripcion:'',
    idFuenteNeocredito: ['', Validators.required],
    nombreReferido: [''],
    codigoReferido: [''],
    otraFuente: [''],
    numeroOpcional:[''],
    idPaisOrigen:[''],
    tiposContacto: ['', Validators.required],
    camaraComercioVigente: ['', Validators.required],
    tratamientoDatos: [null],
  },{
    validator: [this._numeroDocumento.matchPassword('numeroDocumentoP', 'confirmNumeroDocumento'), 
      this._numeroDocumento.matchPassword('numeroDocumento', 'confirmNit')]
  });

  ngOnInit() {
    this.getActividades();
    this.getDocumentos();
    this.getGeneros();
    this.setPipeForm();
    this.getAnios();
    this.getDepartamentos();
    this.getFuentes();
    this.getParametroValorMinVentas();
    this.getParametroDominiosCorreoBloqueados();
    this.getListaTiposContacto();
    this.juridicoForm.get('idTipoDocIdentidad')?.valueChanges?.subscribe(() => {
      this.juridicoForm.get('numeroDocumentoP')?.updateValueAndValidity();
      this.juridicoForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
    });
    this.juridicoForm.get('numeroDocumentoP')?.valueChanges?.subscribe(() => {
      this.juridicoForm.updateValueAndValidity({ emitEvent: false });
    });
    this.juridicoForm.get('numeroDocumento')?.valueChanges?.subscribe((val) => {
      const nitSinDV = String(val || '').replace(/\D/g, '').slice(0, 9);
      this.juridicoForm.get('digitoVerificacion').setValue(String(this.calcularDigitoVerificacionNIT(nitSinDV)), { emitEvent: false });
    });
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
      this.bindCodigoCiiuWrapText();
      this.loadData();
    }, 1000);
  }

  //Cargar selects
  getDocumentos() {
    this._parametro.getTipoDocumentos().subscribe((data: any) => {
      this.documentos = data.filter(
        (documento) => 
          documento.personaJuridica == 0 &&
          documento.idTipoDocIdentidad != 4 &&
          documento.idTipoDocIdentidad != 6
      );
      this.juridicoForm.get('numeroDocumentoP')?.updateValueAndValidity();
      this.juridicoForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
    });
  }

  getGeneros() {
    this._parametro
      .getGeneros()
      .subscribe((data: any) => (this.generos = data));
  }

  getActividades() {
    this._parametro.getCiius().subscribe((data: any) => {
      this.ciius = data?.data ?? [];
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
        this.bindCodigoCiiuWrapText();
      }, 300);
    });
  }

  getAnios() {
    this._parametro
      .getAnios('juridico')
      .subscribe((data: any) => {
        this.anios = data.anios;
        this.anios = this.anios.filter(anio => anio != new Date().getFullYear()-2 &&  anio != new Date().getFullYear());
      });
  }

  getDepartamentos() {
    this._parametro
      .getDepartamentos('169')
      .subscribe((data: any) => (this.departamentos = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los departamentos');
      },
      () => {
        setTimeout(() => {
          $('#idCiudad').prop('disabled', true);
          $('.selectpicker').selectpicker('refresh');
        },300);
      });
  }

  getParametroValorMinVentas() {
    var json = {
      idParametro: 'PAR-118',
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        var respuesta = response['data'];
        this.ventasMinimas = Number(respuesta[0].valorParametro);
        this.validarVentaAnual();
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,error.error);
      }
    );
  }

  getCambio(i){
    this.selectpikerChange('idDepartamento');
    this.juridicoForm.get('idCiudad').setValue('');
    $('.selectpicker').selectpicker('refresh');
    if(i.target.value != 0){
      this.getCiudades(i.target.value);
    }else{
      $('#idCiudad').prop('disabled', true);
      $('.selectpicker').selectpicker('refresh');
    }
  }

  getCiudades(idDepartamento: number) {
    this._parametro
      .getCiudades(idDepartamento.toString()).subscribe((data: any) => (this.ciudades = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar las ciudades');
      },
      () => {
        setTimeout(() => {
          $('#idCiudad').prop('disabled', false);
          $('.selectpicker').selectpicker('refresh');
        },300);
      });
  }

  getFuentes(){
    this._microempresario.getFuentes(
      {
        tiposPersona: [
          {
            idTipoPersonaJuridica: Constantes.TIPO_PERSONA.JURIDICA
          }
        ]
      }      
    ).subscribe((response:any)=>{
      if(response.exitoso){
        this.fuentesInformacion= response.fuentes;
      }else{
        this._sweetAlert.errorModal("Error",true,"Error al cargar las fuentes de información")
      }
    },
    (error) => {
      this._sweetAlert.errorModal("Error!",true,'Error al cargar las fuentes de información');
    });
   }

     /** Carga PAR-160 (dominios de correo bloqueados) y aplica validador al campo correo. */
  getParametroDominiosCorreoBloqueados() {
    const json = {
      idParametro: ActualizarPersonaJuridica.PAR_DOMINIOS_CORREO_BLOQUEADOS,
      nombre: null,
      isParFuncional: true,
      pagina: 1,
    };
    this._bancoldexService.getFilterParametro(json).subscribe(
      (response) => {
        const data = response['data'];
        if (data && data[0] && data[0].valorParametro) {
          const valor = String(data[0].valorParametro).trim();
          this.dominiosCorreoBloqueados = valor
            .split(',')
            .map((d: string) => d.trim().toLowerCase())
            .filter((d: string) => d.length > 0);
        }
        this.agregarValidadorDominioCorreo();
      },
      () => {
        this.agregarValidadorDominioCorreo();
      }
    );
  }

  private agregarValidadorDominioCorreo() {
    const control = this.juridicoForm.get('correoElectronico');
    if (!control) return;
    const validadores = [
      Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9-]+(?:\\.[a-z0-9-]+)*\\.[a-z]{2,4}$'),
      this.dominioCorreoBloqueadoValidator(),
    ];
    control.setValidators(validadores);
    control.updateValueAndValidity({ emitEvent: false });
  }

  private dominioCorreoBloqueadoValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value == null || String(value).trim() === '') return null;
      const idx = String(value).lastIndexOf('@');
      if (idx <= 0 || idx === String(value).length - 1) return null;
      const dominio = String(value).substring(idx + 1).trim().toLowerCase();
      if (this.dominiosCorreoBloqueados.length === 0) return null;
      if (this.dominiosCorreoBloqueados.includes(dominio)) {
        return { dominioCorreoBloqueado: true };
      }
      return null;
    };
  }

  /** Mensaje de error para correo electrónico (requerido, formato, dominio bloqueado). */
  getCorreoElectronicoErrorMessage(): string {
    const c = this.juridicoForm.get('correoElectronico');
    if (!c?.errors) return '';
    if (c.hasError('required')) return 'Campo obligatorio';
    if (c.hasError('dominioCorreoBloqueado')) {
      return 'No está permitido el uso de correos temporales o de dominios no válidos para el registro.';
    }
    if (c.hasError('pattern')) return 'El correo electrónico no tiene una estructura válida (ej: correo@dominio.com).';
    return 'Correo electrónico no válido';
  }

   getPaises(){
    this._parametro
      .getPaises()
      .subscribe((data: any) => (this.paises = data.data),
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los paises');
      });
  }

  getListaTiposContacto(){
    this._microempresario.getListaTipoContacto().subscribe((resp: any) =>{
      this.listaTiposCont = resp;
    },
    (error) => {
      this._sweetAlert.errorModal("Error!",true,error.error);
    });
  }
  //Fin para cargar selects//

  loadData() {
    this._microempresario
      .cargarDatosPersonaJuridica()
      .subscribe((data: any) => {
        if (data.microempresario) {
          this.loadFields(data.microempresario);
        }
      });
  }

  loadFields(empresario: any) {
    this.juridicoForm.get('idEmpresario').setValue(empresario.idEmpresario);
    this.juridicoForm.get('idUsuario').setValue(empresario.idUsuario);
    this.juridicoForm
      .get('idPersonaEmpJuridico')
      .setValue(empresario.idPersonaEmpJuridico);
    this.juridicoForm.get('razonSocial').setValue(empresario.razonSocial);
    this.juridicoForm
      .get('numeroDocumento')
      .setValue(empresario.numeroDocumento);
    this.juridicoForm.get('primerApellido').setValue(empresario.primerApellido);
    this.juridicoForm.get('primerNombre').setValue(empresario.primerNombre);
    this.juridicoForm
      .get('segundoApellido')
      .setValue(empresario.segundoApellido);
    this.juridicoForm.get('segundoNombre').setValue(empresario.segundoNombre);
    this.juridicoForm.get('idGenero').setValue(empresario.idGenero);
    this.juridicoForm.get('numeroCelular').setValue(empresario.numeroCelular);
    this.juridicoForm
      .get('correoElectronico')
      .setValue(empresario.correoElectronico);
     if (empresario.idDepartamento != null && empresario.idDepartamento != 0) {
      this.juridicoForm.get('idDepartamento').setValue(empresario.idDepartamento);
      $('#idDepartamento').selectpicker('val', Number(empresario.idDepartamento));
      this.getCiudades(empresario.idDepartamento);
      this.juridicoForm.get('idCiudad').setValue(empresario.idCiudad);
      $('#idCiudad').selectpicker('val', Number(empresario.idCiudad));
      if (empresario.idCiudad == this.idBogota && empresario.idLocalidad != null) {
        this.juridicoForm.get('idLocalidad').setValue(empresario.idLocalidad);
        $('#idLocalidad').selectpicker('val', Number(empresario.idLocalidad));        
      } else {
        this.juridicoForm.get('idLocalidad').setValue(null);
      }
      this.validarLocalidad();
    }
    this.juridicoForm.get('tiposContacto').setValue(empresario.tiposContacto);
    this.juridicoForm.get('codigoCiiu').setValue(empresario.codigoCiiu);
    this.juridicoForm
      .get('personaDeContacto')
      .setValue(empresario.personaDeContacto);
    this.juridicoForm
      .get('tipoPersonaOtro')
      .setValue(empresario.tipoPersonaOtro ?? '');
    this.setValidators();
    this.juridicoForm
      .get('idTipoDocIdentidad')
      .setValue(empresario.idTipoDocIdentidad);
    this.juridicoForm
      .get('numeroDocumentoP')
      .setValue(empresario.numeroDocumentoP);
    this.juridicoForm.get('valorVentas').setValue(formatPesosCop(empresario.valorVentas));
    const anioGuardado = Number(empresario.anioVentas);
    // Solo enriquecer catálogo con años reales ya guardados (no 0 / vacíos)
    if (anioGuardado > 0 && !this.anios.includes(anioGuardado)) {
      this.anios.push(anioGuardado);
    }
    this.juridicoForm
      .get('anioVentas')
      .setValue(anioGuardado > 0 ? anioGuardado : '');
    this.juridicoForm
      .get('digitoVerificacion')
      .setValue(empresario.digitoVerificacion);
    this.juridicoForm
      .get('idTipoEntidad_NeoTipoEntidad')
      .setValue(empresario.idTipoEntidad_NeoTipoEntidad);
    this.juridicoForm
      .get('idTipoSociedad')
      .setValue(empresario.idTipoSociedad);
    this.juridicoForm.get('minoria').setValue(empresario.minoria);
    this.juridicoForm.get('minoriaDescripcion').setValue(empresario.minoriaDescripcion);
    this.validarMinoria(empresario.minoria);
    this.juridicoForm.get('codigoReferido').setValue(empresario.codigoReferido);
    this.juridicoForm.get('idFuenteNeocredito').setValue(empresario.idFuenteNeocredito);
    this.valueSelected(empresario.idFuenteNeocredito);
    this.juridicoForm.get('nombreReferido').setValue(empresario.nombreReferido);
    this.juridicoForm.get('otraFuente').setValue(empresario.otraFuente);
    this.juridicoForm.get('numeroOpcional').setValue(empresario.numeroOpcional);
    this.juridicoForm.get('idPaisOrigen').setValue(empresario.idPaisOrigen);
    this.juridicoForm.get('camaraComercioVigente').setValue(empresario.camaraComercioVigente);
    this.idPaisOrigenActual = empresario.idPaisOrigen;
    // Tras cargar tipo doc (p. ej. pasaporte): mostrar nacionalidad sin limpiar documentos
    this.actualizarVisibilidadNacionalidad(false);
    this.validarVentaAnual();
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
      this.bindCodigoCiiuWrapText();
      this.validateForm();
    }, 1000);
  }

  submit() {
    const json: personaJuridica = this.juridicoForm.value;
    // Backend exige tratamientoDatos no nulo. Si null (checkbox no mostrado), enviar false para no actualizar fecha en BD
    json.tratamientoDatos = json.tratamientoDatos ?? false;
    const nitSinDV = String(json.numeroDocumento || '').replace(/\D/g, '').slice(0, 9);
    json.digitoVerificacion = String(this.calcularDigitoVerificacionNIT(nitSinDV));
    json.valorVentas = parsePesosCop(this.juridicoForm.get('valorVentas').value);
    json.ciiuNombre = this.ciius.find(
      (c) => c.codigoCiiu == this.juridicoForm.get('codigoCiiu').value
    ).nombreCiiu;
    json.idFuenteNeocredito = Number(json.idFuenteNeocredito);
    json.correoElectronico = json.correoElectronico.toLowerCase().trim();
    json.idLocalidad = json.idLocalidad ? json.idLocalidad : null;
    this._microempresario.updatePersonaJuridico(json).subscribe({
      next: (data: any) => {
        if (data?.faltaInfo) {
          this._sweetAlert.infoModal('Información', true, data.advertencia || 'Hay campos obligatorios sin diligenciar');
          return;
        }
        if (data.exitoso == true) {
          this._sweetAlert.successModal(data.mensaje);
          this.route.navigate(['microempresario/home']);
        } else {
          this._sweetAlert.errorModal('Error!', true, data.error);
        }
      },
      error: (err) => {
        const msg = typeof err === 'string' ? err : 'Error al actualizar los datos';
        this._sweetAlert.errorModal('Error!', true, msg);
      },
    });
  }

  //Validaciones
  validateField(key: string) {
    return (
      (this.juridicoForm.get(key).dirty ||
        this.juridicoForm.get(key)?.touched) &&
      this.juridicoForm.get(key)?.invalid
    );
  }

  /** Mensaje de error para número de documento según tipo (CC/CE/PA). */
  getDocumentPatternMessage(controlName: string): string {
    const control = this.juridicoForm.get(controlName);
    return getDocumentPatternMessage(control);
  }

  /**
   * Cálculo del dígito de verificación NIT (Colombia) según algoritmo módulo 11 DIAN.
   * Pesos de derecha a izquierda: 3, 7, 13, 17, 19, 23, 29, 37, 41.
   */
  private calcularDigitoVerificacionNIT(nitSinDV: string): number {
    const digits = nitSinDV.padStart(9, '0').slice(-9).split('').map(Number);
    const pesos = [41, 37, 29, 23, 19, 17, 13, 7, 3];
    const sum = digits.reduce((s, d, i) => s + d * pesos[i], 0);
    const remainder = sum % 11;
    return remainder <= 1 ? remainder : 11 - remainder;
  }

  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (
      this.juridicoForm.get('idTipoDocIdentidad').value == 5 ||
      this.juridicoForm.get('idTipoDocIdentidad').value == 3
    ) {
      const pattern = /[a-zA-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }
  validarSelect() {
    this.juridicoForm.get('numeroDocumentoP').setValue('');
    this.juridicoForm.get('confirmNumeroDocumento').setValue(null);
    this.juridicoForm.get('numeroDocumentoP')?.updateValueAndValidity();
    this.juridicoForm.get('confirmNumeroDocumento')?.updateValueAndValidity();
    this.actualizarVisibilidadNacionalidad(true);
  }

  /**
   * Nacionalidad visible y requerida si el tipo de doc no es CC (id 2).
   * Aplica a CE, pasaporte, etc. `resetPaisSiCc` solo al cambiar el select (no al cargar datos).
   */
  private actualizarVisibilidadNacionalidad(resetPaisSiCc: boolean): void {
    const tipo = this.juridicoForm.get('idTipoDocIdentidad')?.value;
    const requierePais = tipo != null && tipo !== '' && Number(tipo) !== 2;
    this.isPasaporte = requierePais;
    if (requierePais) {
      this.setearValidadoresForm('idPaisOrigen', [Validators.required]);
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
    } else {
      this.setearValidadoresForm('idPaisOrigen', null);
      if (resetPaisSiCc) {
        this.juridicoForm.get('idPaisOrigen').setValue(this.idPaisOrigenActual);
      }
    }
  }

  setPipeForm() {
    this.juridicoForm.controls['valorVentas'].valueChanges.subscribe((data) => {
      if (data == null || data === '') {
        return;
      }
      this.juridicoForm.patchValue(
        { valorVentas: formatPesosCop(data) },
        { emitEvent: false }
      );
    });
  }

  setValidators() {
    if (this.juridicoForm.get('personaDeContacto').value === 'Otros') {
      this.juridicoForm
        .get('tipoPersonaOtro')
        .setValidators([Validators.required, Validators.maxLength(30)]);
    } else {
      this.juridicoForm.get('tipoPersonaOtro').setValidators(Validators.maxLength(30));
      this.juridicoForm.get('tipoPersonaOtro').setValue('');
    }
    this.juridicoForm.get('tipoPersonaOtro').updateValueAndValidity();
  }

  validateForm() {
    let fuente = this.juridicoForm.get('idFuenteNeocredito').value;
    let nombreReferido = this.juridicoForm.get('nombreReferido').value;
    let codigoReferido = this.juridicoForm.get('codigoReferido').value;
    if (this.juridicoForm.valid) {
      if(fuente=='7'){            
        if((nombreReferido != '' && nombreReferido != null) || (codigoReferido != '' && codigoReferido != null)){
          this.juridicoForm.get('otraFuente').setValue('');
          this.submit();
        }else{
          this._sweetAlert.infoModal("Información",true,"Debe registrar por lo menos uno de los dos campos, ¿Quién te refirió? ó El código del referido")
          this.juridicoForm.get('otraFuente').setValue('');
        }
      }else if(fuente=='8'){
        this.juridicoForm.get('nombreReferido').setValue('');
        this.juridicoForm.get('codigoReferido').setValue('');
        this.submit();
      }if(fuente!='7' && fuente!='8'){
        this.juridicoForm.get('nombreReferido').setValue('');
        this.juridicoForm.get('codigoReferido').setValue('');
        this.juridicoForm.get('otraFuente').setValue('');
        this.submit();
      }
    } else {
      this._sweetAlert.errorModal("Error!",true,'Diligencia correctamente los campos obligatorios antes de continuar la actualización de datos.');
      this.juridicoForm.markAllAsTouched();
      this.selectpikerChange('codigoCiiu');
      this.selectpikerChange('idDepartamento');
      this.selectpikerChange('idCiudad');
      this.selectpikerChange('idFuenteNeocredito');
      this.selectpikerChange('idPaisOrigen');
      this.selectpikerChange('tiposContacto');
      this.selectpikerChange('idLocalidad');
    }
  }

  selectpikerChange(field: string) {
    $(`#${field}`).selectpicker('destroy');
    let valid = this.validateField(field);
    if (!valid) {
      $(`#${field}`).removeClass('is-invalid');
    } else {
      $(`#${field}`).addClass('is-invalid');
    }
    $(`#${field}`).addClass('selectpicker');
    $(`#${field}`).selectpicker('render');
    if (field === 'codigoCiiu') {
      this.bindCodigoCiiuWrapText();
    }
  }

  /** Actividad económica: opciones largas en varias líneas (sin scroll horizontal). */
  private bindCodigoCiiuWrapText(): void {
    const $el = $('#codigoCiiu');
    if (!$el?.length || typeof $el.selectpicker !== 'function') {
      return;
    }
    $el
      .off('shown.bs.select.actividadWrap')
      .on('shown.bs.select.actividadWrap', () =>
        this.styleSelectpickerWrapText($el)
      );
    this.styleSelectpickerWrapText($el);
  }

  private styleSelectpickerWrapText($el: any): void {
    const picker = $el.data('selectpicker');
    if (!picker?.$menu?.length) {
      return;
    }
    const btnWidth = picker.$newElement?.outerWidth?.() || $el.outerWidth();
    const $menu = picker.$menu;
    $menu.addClass('selectpicker-wrap-text-dropdown');
    if (btnWidth) {
      $menu[0].style.setProperty('--selectpicker-wrap-width', `${btnWidth}px`);
      $menu[0].style.setProperty('overflow-x', 'hidden', 'important');
    }
    $menu.find('.inner').css({
      overflowX: 'hidden',
      overflowY: 'auto',
      maxWidth: '100%',
    });
    $menu.find('li a, li a span.text').css({
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
      maxWidth: '100%',
      display: 'block',
    });
  }

  validarMinoria(numero:number) {
    if (numero == 1) {
      this.setearValidadoresForm('minoriaDescripcion', [
        Validators.required,
      ]);
    } else {
      this.setearValidadoresForm('minoriaDescripcion', null);
      this.juridicoForm.get('minoriaDescripcion').setValue('');
    }
  }

  onCiudadChange() {
    this.selectpikerChange('idCiudad');
    this.validarLocalidad();
  }

  validarLocalidad() {
    if (this.juridicoForm.get('idCiudad').value == this.idBogota) {
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
      this.setearValidadoresForm('idLocalidad', [Validators.required])
    } else {
      this.setearValidadoresForm('idLocalidad', null)
      this.juridicoForm.get('idLocalidad').setValue(null);
    }
  }

  setearValidadoresForm(
    nombreCampo: string,
    validadores: any
  ) {
    this.juridicoForm.controls[nombreCampo].setValidators(
      validadores
    );
    this.juridicoForm.controls[
      nombreCampo
    ].updateValueAndValidity();
  }

  validarTexto(e){
    e.target.value = this.title.transform(e.target.value);
  }

  valueSelected(valueId:any){
    this.selectpikerChange('idFuenteNeocredito');
    if(valueId == '7'){
      this.isReferido=true;
      this.isOtraFuente=false;
      this.setearValidadoresForm('otraFuente',null);
    }else if(valueId == '8'){
      this.isOtraFuente=true;
      this.isReferido=false;
      this.setearValidadoresForm('otraFuente',[Validators.required]);
    }else{
      this.isReferido=false;
      this.isOtraFuente=false;
      this.setearValidadoresForm('otraFuente',null);
    }
  }

  validarVentaAnual(){
    const ventaMinima = formatPesosCop(this.ventasMinimas);
    if (this.juridicoForm.get('valorVentas').value) {
      if (parsePesosCop(this.juridicoForm.get('valorVentas').value) < this.ventasMinimas) {
        this.juridicoForm.get('valorVentas').setErrors({ incorrect: true });
        this.msjErrorValorVentas = "Campo obligatorio. El monto mínimo es de " + ventaMinima + " pesos.";
      }
    }else{
      this.msjErrorValorVentas = "Campo obligatorio";
    }
  }

  selectpikerChangeContactos(field: string) {
    let valid = this.validateField(field);
    const tiposContactoElement = document.getElementById('tiposContacto');
    if (valid) {
      tiposContactoElement.classList.add('is-invalid');
    } else {
      if (tiposContactoElement.classList.contains('is-invalid')) {
        $(`#${field}`).selectpicker('destroy');
      }
      tiposContactoElement.classList.remove('is-invalid');
    }
    $(`#${field}`).selectpicker('refresh');
  }
  
  autorizarDatos(){
    this.setearValidadoresForm('tratamientoDatos', [
      Validators.required, Validators.requiredTrue
    ]);
    this.isAutorizarDatos = true;
  }

  showModal(title: string) {
    this.titleModal = title;
  }

  goToNextStep() {
    this.markFieldsAsTouched(this.step1Fields);
    this.markConditionalFieldsTouchedStep1();
    if (this.isStep1Valid()) {
      if (this.juridicoForm.get('idCiudad').value === '') {
        $('#idCiudad').prop('disabled', true);
      }
      this.currentStep = 2;
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      }, 300);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this._sweetAlert.errorModal(
        'Error!',
        true,
        'Diligencia correctamente los campos obligatorios de Información general y financiera antes de continuar.'
      );
    }
  }

  goToPreviousStep() {
    if (this.currentStep === 1) {
      this.route.navigate(['microempresario/home']);
      return;
    }
    // codigoCiiu está en paso 1 (@if): al volver hay que reenlazar wrap (el DOM se recrea)
    this.currentStep = 1;
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
      this.bindCodigoCiiuWrapText();
    }, 300);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  isStep1Valid(): boolean {
    const baseValid = this.step1Fields.every((field) => {
      const control = this.juridicoForm.get(field);
      if (!control) return false;
      // No exigir validación en controles deshabilitados (ej. digitoVerificacion, valor derivado del NIT)
      if (control.disabled) return true;
      return control.valid;
    });
    if (!baseValid) return false;
    if (this.juridicoForm.get('idCiudad')?.value === this.idBogota && !this.juridicoForm.get('idLocalidad')?.valid) return false;
    return true;
  }

  isStep2Ready(): boolean {
    const baseValid = this.step2Fields.every((field) => this.juridicoForm.get(field)?.valid);
    if (!baseValid) return false;
    if (this.juridicoForm.get('personaDeContacto')?.value === 'Otros' && !this.juridicoForm.get('tipoPersonaOtro')?.valid) return false;
    if (this.isPasaporte && !this.juridicoForm.get('idPaisOrigen')?.valid) return false;
    if (this.juridicoForm.get('minoria')?.value === 1 && !this.juridicoForm.get('minoriaDescripcion')?.valid) return false;
    if (this.isReferido) {
      const nom = (this.juridicoForm.get('nombreReferido')?.value ?? '').toString().trim();
      const cod = (this.juridicoForm.get('codigoReferido')?.value ?? '').toString().trim();
      if (!nom && !cod) return false;
    }
    if (this.isOtraFuente && !this.juridicoForm.get('otraFuente')?.valid) return false;
    if (this.isAutorizarDatos && !this.juridicoForm.get('tratamientoDatos')?.valid) return false;
    return true;
  }

  private markFieldsAsTouched(fields: string[]) {
    fields.forEach((field) => {
      const control = this.juridicoForm.get(field);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });
  }

  private markConditionalFieldsTouchedStep1() {
    if (this.juridicoForm.get('idCiudad')?.value === this.idBogota) {
      this.juridicoForm.get('idLocalidad')?.markAsTouched();
      this.juridicoForm.get('idLocalidad')?.updateValueAndValidity();
    }
  }
}
